var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24467",
    "data-name": "Group 24467",
    transform: "translate(2375 -4577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24469",
    "data-name": "Group 24469",
    transform: "translate(-11 -1578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(-2360 6159)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24189",
    "data-name": "Group 24189",
    transform: "translate(-2355.141 6161.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M4.552-3.76H3.146v-.718a3.041,3.041,0,0,1,.075-.7,2.206,2.206,0,0,1,.217-.568,2.877,2.877,0,0,1,.344-.486q.2-.232.456-.471l.553-.524a2.889,2.889,0,0,0,.546-.621,1.561,1.561,0,0,0,.217-.86A1.491,1.491,0,0,0,5.1-9.855a1.651,1.651,0,0,0-1.174-.426,1.562,1.562,0,0,0-1.2.479A1.968,1.968,0,0,0,2.2-8.636L.768-8.8A3.336,3.336,0,0,1,1.142-9.96a3.06,3.06,0,0,1,.71-.875,2.991,2.991,0,0,1,.98-.546,3.668,3.668,0,0,1,1.182-.187,3.737,3.737,0,0,1,1.174.179,2.886,2.886,0,0,1,.965.531,2.476,2.476,0,0,1,.658.868A2.8,2.8,0,0,1,7.05-8.8a3,3,0,0,1-.1.838,2.49,2.49,0,0,1-.292.651,2.916,2.916,0,0,1-.456.546q-.269.254-.583.524t-.509.456a1.861,1.861,0,0,0-.329.411,1.563,1.563,0,0,0-.172.464,3.181,3.181,0,0,0-.052.628Zm.374,2.109a.97.97,0,0,1-.284.688.948.948,0,0,1-.718.3.967.967,0,0,1-.71-.292.933.933,0,0,1-.292-.681.962.962,0,0,1,.284-.7.96.96,0,0,1,.718-.292.973.973,0,0,1,.718.284A.937.937,0,0,1,4.926-1.651Z",
    transform: "translate(-0.768 11.568)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10135",
    "data-name": "Rectangle 10135",
    width: 24,
    height: 24,
    transform: "translate(-2375 4577)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.6093e8e76038659e2e2121c5fc49b061.svg";
export { ForwardRef as ReactComponent };